function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 45",
    height: 24,
    id: "Layer_45",
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    height: 9,
    style: {
      fill: "#e8ab87"
    },
    width: 5,
    x: 4,
    y: 10
  }), /*#__PURE__*/React.createElement("rect", {
    height: 10,
    style: {
      fill: "#4c9ae8"
    },
    width: 3,
    x: 2,
    y: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1252,18.32728,21,12.5V11a2,2,0,0,0-2-2H14V4a1,1,0,0,0-1-1H12L7.66475,8.37578A3,3,0,0,0,7,10.259V18a2,2,0,0,0,2,2h6.43478A3,3,0,0,0,18.1252,18.32728Z",
    style: {
      fill: "#ffc89e"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.a9ac7230f38b1eaf8276b1f4346aa1a0.svg";
export { ForwardRef as ReactComponent };